export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#2EBEEF',
    contrastText: '#FFFFFF',
    light: '#E9F3F6',
  },
  secondary: {
    main: '#005994',
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#25272C',
    primaryLight: '#4F5A6B',
    description: '#49515B',
    headerhighlight: '#005994',
    secondary: '#25272C',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    subtle: '#7C8694',
    alternate: '#57D4FF'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#D5E9F2',
    heroOther: '#005994',
    paper: '#FFF',
    dark: '#002035',
    default: '#FFF',
    footer: '#002035',
    level2: '#C9D5E0',
    level1: '#51B9F5',
    tableHead: '#005994',
    tableSubhead: '#E7EFF5',
    tableBorder: '#EDEEF1',
    tableAlternate: '#F8F8F8',
    cardBorder: '#D7DBE0',
    alternate: '#E3F1FD',
    greySubtle: '#F7F8F8',
    greySubtler: '#FAFAFA',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: 'linear-gradient(to right, #43B9EE, #D5E9F2);',
    pricing: '#005994',
    selectedtab: '#2EBEEF',
    secondary: '#3E89BB',
    disclaimer: "#04212B",
  },
  verticalBar: {
    used: '#40A8E4',
    unused: '#d5e9f2',
    unlimited: '#C0C0C0',
  }
};
